module.exports = function() {
  return new Worker(__webpack_public_path__ + "3795935ed3d4de8af168.worker.js");
};